/**
 * 页面URL与名称的映射
 * 为了大数据同事的要求
 */
import utilUrl from '../../url';

export const pages = [
  // 搜索列表页
  {
    name: 'poi_searchlist',
    match: [/^\/tantu(\/)?$/, /^\/tantu\/(index|list)\.php/] // pathname
  },
  {
    name: 'activity_newusers'
  },
  {
    name: 'activity_phonecards'
  },
  // 商品详情页
  {
    name: 'poidetails',
    match: /^\/tantu\/goods\/goods\.php$/
  },
  // 预定页
  {
    name: 'booking',
    match: /^\/tantu\/webapp\/book(\/)?/
  },
  // 填写订单信息页
  {
    name: 'order_completion',
    match: /^\/tantu\/webapp\/orders\/new(\/)?$/
  },
  // 下单后领券的专属优惠页
  {
    name: '/tantu/webapp/exclusive-discount-list',
    match: /^\/tantu\/webapp\/exclusive-discount-list(\/)?$/
  },
  // 定制游用户信息收集页
  {
    name: '/tantu/webapp/customized-tour/gather-user-info',
    match: /^\/tantu\/webapp\/customized-tour\/gather-user-info(\/)?$/
  },
  // 银联活动页
  {
    name: '/tantu/webapp/activity/union-pay',
    match: /^\/tantu\/webapp\/activity\/union-pay(\/)?$/
  },
  // 银联活动v2
  {
    name: '/tantu/webapp/activity/union-pay-discounts',
    match: /^\/tantu\/webapp\/activity\/union-pay-discounts(\/)?$/
  },
  // 内容文章
  {
    name: 'article',
    match: /^\/tantu\/webapp\/articles\/[0-9]+(\/)?$/
  },
  // 头条内容文章
  {
    name: 'yh-detail',
    match: /^\/tantu\/webapp\/headline\/[0-9]+(\/)?$/
  },
  // 选择目的地页
  {
    name: 'choose_destination',
    match: /^\/tantu\/webapp\/destination/
  },
  // 旅行商城首页
  {
    name: 'poi_mall',
    match: /^\/tantu\/webapp\/homepage/
  },
  // 路线详情
  {
    name: 'route',
    match: /^\/tantu\/webapp\/routes/
  },
  // 榜单文章
  {
    name: 'rank_article',
    match: /^\/tantu\/webapp\/expected-goods/
  },
  // 榜单详情
  {
    name: 'rank',
    match: /^\/tantu\/webapp\/rank-list/
  },
  {
    name: 'double11',
    match: /^\/tantu\/webapp\/activity\/1111/
  },
  {
    name: 'punch',
    match: /^\/tantu\/webapp\/activity\/punch/
  },
  {
    name: 'yh-list',
    match: /^\/tantu\/webapp\/innovation\/discount-headline-list/
  },
  {
    name: 'punch-landing',
    match: /^\/tantu\/webapp\/punch\/landing/
  },
  {
    name: 'zzc_search',
    match: /^\/tantu\/webapp\/global\/search/
  }
];


function matchPath(match, pathname) {
  if (typeof match === 'function') {
    return match(pathname);
  }

  if (match instanceof RegExp) {
    return match.test(pathname);
  }

  if (match instanceof Array) {
    for (let i = 0, len = match.length; i < len; i += 1) {
      if (matchPath(match[i], pathname)) {
        return true;
      }
    }
  }
  return false;
}

export function getPageNameFromUrl(url) {
  url = url || '';
  const pathname = utilUrl.parse(url).pathname;
  let result = '';
  for (let i = 0, len = pages.length; i < len; i += 1) {
    const item = pages[i];
    const match = item.match;

    if (matchPath(match, pathname)) {
      result = item.name;
      break;
    }
  }

  return result;
}
